var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:{ active: _vm.isActive },on:{"click":_vm.handleClick}},[_c('p',[_vm._v(_vm._s(_vm.count))]),_c('font-awesome-icon',{attrs:{"icon":"heart"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }